// we need to disable two eslint rules because we use @internal true as custom parameter,
// which is actually a valid jsdoc tag, that has no value true.
/* eslint-disable jsdoc/valid-types */
/* eslint-disable jsdoc/empty-tags */

import type { Target } from './page';
import type { Pages as PagesV2, AppSettings as AppSettingsV2 } from '../v2';
import type { Pages as PagesV4, AppSettings as AppSettingsV4 } from '../v4';
import type { FlexibleColumnLayoutType } from './types';

export enum DraftDiscardEnabledSettings {
    restricted = 'restricted'
}
export interface DraftDiscardConfirmationSettings {
    /**
     * Allows applications to turn off the discard draft confirmation popup in various scenarios.
     */
    enabled: DraftDiscardEnabledSettings;
}

export enum TableColumnVerticalAlignment {
    Top = 'Top',
    Middle = 'Middle',
    Bottom = 'Bottom'
}

export enum StatePreservationMode {
    persistence = 'persistence',
    discovery = 'discovery'
}

export interface Application {
    $schema?: string;
    id?: string;
    pages?: PagesV2 | PagesV4;
    home?: string;
    target?: Target;
    settings?: AppSettingsV2 | AppSettingsV4;
}

export enum FlexibleColumnLayoutAggregations {
    BeginColumnPages = 'beginColumnPages',
    MidColumnPages = 'midColumnPages',
    EndColumnPages = 'endColumnPages'
}

/**
 * @internal true
 */
export enum CloudDevAdaptationStatus {
    Released = 'released',
    Deprecated = 'deprecated',
    Obsolete = 'obsolete'
}

/**
 * @descriptionSrcURL https://ui5.sap.com/sdk/#/topic/e762257125b34513b0859faa1610b09e
 */
export interface FlexibleColumnLayout {
    defaultTwoColumnLayoutType?: FlexibleColumnLayoutType;
    defaultThreeColumnLayoutType?: FlexibleColumnLayoutType;
}

export interface CommonAppSettings {
    /**
     * Defines the title for the application.
     *
     * @i18nClassification TIT: Title of the application
     */
    title?: string;
    /**
     * Defines the description for the application.
     *
     * @i18nClassification TIT: Description of the application
     */
    description?: string;
    /**
     * Enables key user adaptation for an application.
     *
     * @descriptionSrcURL https://ui5.sap.com/sdk/#/topic/ccd45ba3f0b446a0901b2c9d42b8ad53
     */
    flexEnabled?: boolean;
    /**
     * Represents the release status for the developer adaptation in the cloud (relevant for SAP internal only). The supported types are released, deprecated, obsolete, no value means not released.
     */
    cloudDevAdaptationStatus?: CloudDevAdaptationStatus;
}
